import { useLingui } from '@lingui/react/macro';
import _ from 'lodash';
import { getSportTypeLabel } from 'modules/core/domain/constants/sport-type-labels';
import { SportType } from 'modules/core/domain/enums/sport-type';
import { FocusEvent } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { AppDispatch } from 'store/store';
import UDSearchInput from 'ud-ui/components/search';
import UDFormLabeledSelect from 'ud-form/components/labeled-select';
import { selectFilterByName, selectSortByDate } from 'modules/template-editor/store/templates/selectors';
import { setFilterByName, setSortByDate } from 'modules/template-editor/store/templates/templates';

function Header() {
  const { t } = useLingui();
  const dispatch = useDispatch<AppDispatch>();
  const sortByDate = useSelector(selectSortByDate);
  const filterByName = useSelector(selectFilterByName);

  const searchInput = {
    label: 'Поиск по тексту:',
    value: filterByName,
    placeholder: 'Название шаблона',
    onChange: (event: FocusEvent<HTMLInputElement, Element>) => {
      dispatch(setFilterByName(event.target.value));
    },
  };

  const sortByDateOptions = [
    { value: 'none', label: 'Все' },
    { value: 'desc', label: 'Новые' },
    { value: 'asc', label: 'Старые' },
  ];
  const sortByData = {
    headerText: 'Сортировать по дате:',
    options: sortByDateOptions,
    value: sortByDateOptions.find(({ value }) => value === sortByDate) ?? sortByDateOptions[0],
    onChange: (value: { label: string | number | JSX.Element; value: string } | undefined) => {
      const val = value?.value;
      if (val) {
        dispatch(setSortByDate(val as 'asc' | 'desc' | 'none'));
      }
    },
  };

  const sportTypes = _.keys(SportType).map((key) => {
    const label = getSportTypeLabel(key);
    return { value: key, label: _.capitalize(label ? t(label) : key) };
  });
  sportTypes.unshift({ value: 'all', label: 'Все' });
  const filterBySport = {
    headerText: 'Тип спорта:',
    options: sportTypes,
    value: sportTypes.find(({ value }) => value === '') ?? sportTypes[0],
  };

  return (
    <div className={'flex'} style={{ gap: 20, marginTop: 18, paddingInline: 24 }}>
      <UDSearchInput style={{ width: 451 }} iconPosition="icon-left" {...searchInput} />
      <UDFormLabeledSelect style={{ width: 171 }} {...sortByData} />
      <UDFormLabeledSelect disable={true} style={{ width: 200 }} {...filterBySport} />
    </div>
  );
}

export default Header;
